import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getSystemMessage(pageNum,pageSize) {
  return request({
    url: '/message/getSystemMessage',
    params: {
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function delByMessageId(id) {
  return requestMsg({
    url: '/message/delByMessageId',
    params: {
      id:id
    }
  })
}

export function getMessageById(id) {
  return request({
    url: '/message/getMessageById',
    params: {
      id:id
    }
  })
}

export function updateMessage(merchants) {
  return requestMsg({
    url: '/message/updateMessage',
    data: JSON.stringify(merchants),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}
